import React from 'react';
import { Tab } from '@mui/material';
import { CountLabel, RecordTabs } from 'components/record-shell/RecordShell';

interface DoctorTabProps {
  tab: string;
  onChange: (newTab: string) => void;
  // médico já cadastrado: a ficha é a primeira aba
  showRecord?: boolean;
  banksCount?: number;
}

const DoctorTab: React.FC<DoctorTabProps> = ({ tab, onChange, showRecord, banksCount }) => {
  return (
    <RecordTabs tab={tab} onChange={onChange}>
      {showRecord && <Tab value="record" label="Ficha" />}
      <Tab value="main" label="Dados do médico" />
      <Tab value="address" label="Endereço" />
      <Tab value="banks" label={<CountLabel label="Dados bancários" count={banksCount} />} />
    </RecordTabs>
  );
};

export default DoctorTab;
